export enum FieldType {
  INPUT,
  IBAN,
  SELECT,
  CHECKBOX,
  SWITCHER,
  PRIVACY,
  TITLE,
  FILE_UPLOAD,
  TEXT_AREA,
  RADIO,
  TEXT_BOX,
  DATE,
  NOTIFICATION_BOX,
  CUSTOM,
  TOGGLE_BUTTON
}
